import { Card, Grid, InputLabel, Autocomplete, TextField, Checkbox, ListItemText, MenuItem, Select, OutlinedInput } from "@mui/material";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useEffect, useState } from "react";
import { get, postNoResponse } from "utils/WebService";
import MDSnackbar from "components/MDSnackbar";

export default function FilaProcessamento() {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [regras, setRegras] = useState([]);
    const [operadores, setOperadores] = useState([]);
    const [selectedRegra, setSelectedRegra] = useState(null);
    const [selectedOperadores, setSelectedOperadores] = useState([]);

    const [loading, setLoading] = useState(false);
    const [successSB, setSuccessSB] = useState(false);
    const [errorSB, setErrorSB] = useState(false);
    const [sbMessage, setSbMessage] = useState("");

    useEffect(() => {
        // Carrega as Regras
        get("/regra-fila/list-all").then((res) => {
            if (res) {
                setRegras(res.filter(r => r.ativo)); // apenas ativas
            }
        });

        // Carrega Operadores da Equipe
        get("/users/list-all-operators").then((res) => {
            if (res) {
                setOperadores(res.list || res.data || (Array.isArray(res) ? res : []));
            }
        });
    }, []);

    // Autocomplete handler replaces handleChangeOperadores

    const handleProcessar = () => {
        if (!selectedRegra) {
            setSbMessage("Selecione uma regra para processamento.");
            setErrorSB(true);
            return;
        }

        if (!selectedOperadores || selectedOperadores.length === 0) {
            setSbMessage("Selecione pelo menos um operador.");
            setErrorSB(true);
            return;
        }

        setLoading(true);

        const payload = {
            regraId: selectedRegra.id,
            userIds: selectedOperadores
        };

        postNoResponse("/regra-fila/processar", payload)
            .then(() => {
                setSbMessage("Processamento concluído com sucesso!");
                setSuccessSB(true);
                // Limpa os campos
                setSelectedRegra(null);
                setSelectedOperadores([]);
            })
            .catch(() => {
                setSbMessage("Erro ao processar fila.");
                setErrorSB(true);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <Grid container display="flex" justifyContent="center">
            <Grid item xs={12} md={12}>
                <Card variant="outlined" sx={{ px: 2, py: 1.5, mb: 2, background: darkMode ? "#23233a" : "#fafafa", borderColor: darkMode ? "#333" : "#ddd" }}>
                    <MDBox mb={2}>
                        <MDTypography variant="h6" fontWeight="medium">
                            Processamento de Fila de Trabalho
                        </MDTypography>
                        <MDTypography variant="button" color="text">
                            Escolha a regra de ordenação e a equipe para montar a fila de trabalho de amanhã.
                        </MDTypography>
                    </MDBox>

                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Regra de Ordenação</InputLabel>
                            <Autocomplete
                                options={regras}
                                getOptionLabel={(option) => option.nome}
                                value={selectedRegra}
                                onChange={(event, newValue) => setSelectedRegra(newValue)}
                                renderInput={(params) => <TextField {...params} variant="standard" placeholder="Selecione a Regra..." />}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <InputLabel sx={{ px: 1, pb: 0.5, pt: 0.2 }}>Operadores da Equipe</InputLabel>
                            <Autocomplete
                                multiple
                                options={operadores}
                                getOptionLabel={(option) => option.nome || option.ccNome || option.id || ""}
                                value={operadores.filter(op => selectedOperadores.includes(op.id))}
                                onChange={(event, newValue) => {
                                    setSelectedOperadores(newValue ? newValue.map(v => v.id) : []);
                                }}
                                isOptionEqualToValue={(option, value) => option.id === value?.id}
                                renderInput={(params) => (
                                    <MDInput {...params} variant="standard" placeholder="Selecione os operadores..." />
                                )}
                                fullWidth
                                noOptionsText="Nenhum operador encontrado"
                            />
                        </Grid>

                        <Grid item xs={12} display="flex" justifyContent="flex-end" mt={1}>
                            <MDButton 
                                variant="contained" 
                                color="info" 
                                size="medium" 
                                onClick={handleProcessar}
                                disabled={loading}
                            >
                                {loading ? "PROCESSANDO..." : "PROCESSAR FILA"}
                            </MDButton>
                        </Grid>
                    </Grid>
                </Card>
            </Grid>

            <MDSnackbar
                color={successSB ? "success" : "error"}
                icon={successSB ? "check" : "warning"}
                title={successSB ? "Sucesso" : "Erro"}
                content={sbMessage}
                dateTime=""
                open={successSB || errorSB}
                onClose={() => { setSuccessSB(false); setErrorSB(false); }}
                close={() => { setSuccessSB(false); setErrorSB(false); }}
                bgWhite
            />
        </Grid>
    );
}
